<ng-container *ngIf="showGrandfatheringBanner$ | async">
  <glxy-alert [border]="true" [borderRadius]="false" type="error" [showClose]="true" (close)="onBannerClosed()">
    <strong>{{ 'INBOX.BANNER.SMS_UNAVAILABLE_TITLE' | translate }}</strong>
    {{ 'INBOX.BANNER.SMS_UNAVAILABLE_DESCRIPTION' | translate }}
  </glxy-alert>
</ng-container>
<ng-container *ngIf="(registrationStatus$ | async) === RegistrationStage.DataError">
  <glxy-alert
    [border]="true"
    [borderRadius]="false"
    [showAction]="true"
    actionTitle="{{ 'INBOX.WARNING.A2P_REJECTED_BANNER_ACTION' | translate }}"
    [actionRouterLink]="registrationFormRoute$ | async"
    type="error"
  >
    <strong>{{ 'INBOX.WARNING.A2P_BANNER_TITLE' | translate }}</strong>
    {{ 'INBOX.WARNING.A2P_REJECTED_BANNER_DESCRIPTION' | translate }}
  </glxy-alert>
</ng-container>
